// @flow
import * as React from "react";
import {injectIntl} from "react-intl";
import {reisy, use} from "reisy";

import type {PositionItem} from "../api/items.js";
import Flow from "../publishables/flow.js";
import Navigation from "../navigation/index.js";
import Heading from '../components/heading';

const messages = {
	title: {
		id: "toplikes.title",
		defaultMessage: "most-liked stories",
	}
};

const styles = reisy`
@namespace TopLiked;

JackInTheBox: $Settings.JackInTheBox;

Container {
	@extends Helpers.Fullscreen;

	$Box.box {
		margin: 1.5625em auto;
	}
}
Contain {
	@extends Helpers.Contain;
}

Title {
	margin: 1.6em 0 .15em 0;
	font-family: $Fonts.title;
	font-size: 2.5em;
	text-align: center;
}
`;

type Props = {
	term: string;
	results: Array<PositionItem>;
	intl: any; // TODO: properly type
};

const TopLiked = ({intl: {formatMessage}, term, results}: Props) => (
	<div {...use(styles.Container, styles.JackInTheBox && styles.Contain)}>
		<Navigation styles={styles} />
		<Heading lvl={1} {...use(styles.Title)}>{formatMessage(messages.title)}</Heading>
		{Flow("tile", formatMessage, results, true, undefined, messages)}
	</div>
);

export default injectIntl(TopLiked);



// WEBPACK FOOTER //
// ./lib/screens/top-liked.js